export default __webpack_public_path__ + "static/media/logo.481643fa.png";